import { Link } from "react-router-dom";
import { activeTab, type Item } from "./model";

/** Tab bar for a menu entry that covers several pages (spec §6). */
export function PageTabs({ item, pathname }: { item: Item | null; pathname: string }) {
  if (!item?.tabs || item.tabs.length < 2) return null;
  const current = activeTab(item, pathname);
  return (
    <div className="content-inner" style={{ paddingTop: 0, paddingBottom: 0 }}>
      <nav className="page-tabs" aria-label={`${item.label} sections`}>
        {item.tabs.map((t) => (
          <Link
            key={t.path}
            to={t.path}
            className={"btn btn-sm " + (t === current ? "btn-secondary" : "btn-ghost")}
            aria-current={t === current ? "page" : undefined}
          >
            {t.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
